import(/* webpackMode: "eager", webpackExports: ["DurationSelector"] */ "/home/runner/work/Planner/Planner/src/components/goals/DurationSelector.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GoalForm"] */ "/home/runner/work/Planner/Planner/src/components/goals/GoalForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GoalList"] */ "/home/runner/work/Planner/Planner/src/components/goals/GoalList.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GoalQueue"] */ "/home/runner/work/Planner/Planner/src/components/goals/GoalQueue.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GoalSlot"] */ "/home/runner/work/Planner/Planner/src/components/goals/GoalSlot.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GoalsPage"] */ "/home/runner/work/Planner/Planner/src/components/goals/GoalsPage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GoalsProgress"] */ "/home/runner/work/Planner/Planner/src/components/goals/GoalsProgress.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GoalsTabs"] */ "/home/runner/work/Planner/Planner/src/components/goals/GoalsTabs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Reminders"] */ "/home/runner/work/Planner/Planner/src/components/goals/Reminders.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RemindersTab"] */ "/home/runner/work/Planner/Planner/src/components/goals/RemindersTab.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TimerRing"] */ "/home/runner/work/Planner/Planner/src/components/goals/TimerRing.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TimerTab"] */ "/home/runner/work/Planner/Planner/src/components/goals/TimerTab.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/Planner/Planner/src/components/goals/useGoals.ts");
